export enum ProdLocationsEnum {
	GaslampPlazaSuites         = 3, // cbe24558-bda5-4204-8c36-ccff81e336e2
	GrangerHotelGaslampQuarter = 6, // 222a1403-57c1-4cb5-81ec-95ea7cc06c69
}
